<div class="mt-3">
  <label for="foremanSelector" class="form-label">View by Employees</label>

  <ng-select
    [items]="foremen"
    [multiple]="true"
    bindLabel="name"
    bindValue="id"
    placeholder="Select or start typing..."
    [formControl]="formControl"
    [closeOnSelect]="false"
    [clearSearchOnAdd]="true"
    [loading]="isLoading"
    (change)="onSelectionChange($event)"
  >
    <ng-template ng-option-tmp let-item="item">
      <input
        type="checkbox"
        [checked]="formControl.value?.includes(item.id)"
      />
      {{ item.name }}
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @if (allSelected) {
        <div class="ng-value">
          <span class="ng-value-label">All Employees</span>
          <span class="ng-value-icon right" (click)="clearAll()" aria-hidden="true">×</span>
        </div>
      } @else {
        @for (item of items; track item) {
          <div class="ng-value">
            <span class="ng-value-label">{{ item.name }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
          </div>
        }
      }
    </ng-template>
  </ng-select>
</div>
